import { CardSection } from '@components/CardSection'
import { CardSectionButton } from '@components/CardSectionButton'
import { QuantitySelector } from '@components/QuantitySelector'
import { RateCurrency } from 'shared/price-utilities'
import { withTranslate } from 'i18n/utils'
import { RATE_TYPE_MONTHLY_PASS } from 'subscription-flow/constants'

const $ProductWithRates = ({ selectedRate, prd, selectRate, changeQuantity, translate: t }) => {
    const isRateSelected = rate => selectedRate?.rateId === rate.ratePlanId

    const isPromoRate = rate => !!rate.promoCode && rate.promoCode !== ''

    return (
        <CardSection
            activeSelected={selectedRate && prd.prdctCd === selectedRate.prdctCd}
            notActive
            className="px-3 py-3 mt-3">
            <div className="d-sm-flex justify-content-between">
                <div className="d-flex flex-column">
                    <span className="font-weight-bold">{prd.prdctName}</span>
                    <span className="text-light text-small">{prd.prdctLongDesc}</span>
                </div>
                <div className="d-flex flex-wrap flex-row">
                    {prd.ratePlans?.map((rate, i) => (
                        <CardSectionButton
                            key={i}
                            onClick={() => selectRate(rate)}
                            value={<RateCurrency value={rate.price} currency={rate.currencySymbol} />}
                            isCapitalizeCase
                            description={
                                rate.rateType === RATE_TYPE_MONTHLY_PASS
                                    ? t('subscription.purchase.rate.type.monthlypass')
                                    : rate.name
                            }
                            isSelected={isRateSelected(rate)}
                            isSpecialValue={isRateSelected(rate) && isPromoRate(rate)}
                        />
                    ))}
                </div>
            </div>
            {changeQuantity && (
                <QuantitySelector
                    value={(prd.prdctCd === selectedRate?.prdctCd && selectedRate?.quantity) || 1}
                    changeQuantity={v => changeQuantity(prd.prdctCd, v)}
                    disabled={prd.prdctCd !== selectedRate?.prdctCd}
                    className="justify-content-end mt-2"
                />
            )}
        </CardSection>
    )
}

export const ProductWithRates = withTranslate($ProductWithRates)
